import { FC, ReactNode, useMemo } from 'react';
import { Organization, OrganizationPermissionFlag } from '@robocorp/robocloud-internal-cds-sdk';
import { useCurrentOrganization } from '~/queries';

interface Props {
  permission: OrganizationPermissionFlag;
  children: ReactNode;
}

/**
 * Renders child component if current user in current organization have requested permissions
 */
export const CurrentOrganizationRestriction: FC<Props> = ({ children, permission }) => {
  const { data: currentOrganization } = useCurrentOrganization();

  const organizationPermissions = currentOrganization?.permissions;
  const hasPermission = useMemo(
    () => organizationPermissions?.includes(permission),
    [organizationPermissions, permission],
  );

  return hasPermission ? <>{children}</> : null;
};

interface OrganizationPermissionProps extends Props {
  organization?: Organization;
}

/**
 * Renders child component if current user in organization have requested permissions
 */
export const OrganizationRestriction: FC<OrganizationPermissionProps> = ({
  children,
  permission,
  organization,
}) => {
  const organizationPermissions = organization?.permissions;
  const hasPermission = useMemo(
    () => organizationPermissions?.includes(permission),
    [organizationPermissions, permission],
  );

  return hasPermission ? <>{children}</> : null;
};
